import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type UseUpdateUserSettingsOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useUpdateUserSettings = ({
  onSuccess,
  onError,
}: UseUpdateUserSettingsOptions = {}) => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (settings: Record<string, unknown>) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/settings`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(settings),
        },
      );
      if (!response.ok) {
        throw new Error('Failed to update user settings');
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['profile'] });
      onSuccess?.();
    },
    onError,
  });
};
